export default __webpack_public_path__ + "static/media/me3_ECAP_Statistics_Icon.47958497.svg";